import _Form from "@hzero-front-ui/hzero-ui/lib/Form";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from "styled-components";
export var ButtonItems = styled(_Form.Item)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-btn {\n    margin-left: 8px;\n  }\n"])));